import React, { useState, useEffect, useRef } from "react";
import SortBy from "../Icons/SortBy";

export type SortOrder = "asc" | "desc";

export interface SortFilterDropdownProps {
  sortFields: string[];
  defaultField?: string;
  onChange: (field: string, order: SortOrder) => void;
  defaultSortOrder?: SortOrder;
}

const SortFilterDropdown: React.FC<SortFilterDropdownProps> = ({
  sortFields,
  defaultField,
  onChange,
  defaultSortOrder
}) => {
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [selectedField, setSelectedField] = useState<string>(
    defaultField || sortFields[0]
  );
  const [sortOrder, setSortOrder] = useState<SortOrder>(defaultSortOrder || "desc");

  const dropdownRef = useRef<HTMLDivElement>(null);

  const toggleDropdown = () => setDropdownOpen((prev) => !prev);

  const handleFieldChange = (field: string) => {
    setSelectedField(field);
    setDropdownOpen(false);
    onChange(field, sortOrder);
  };

  const toggleSortOrder = (e: React.MouseEvent<HTMLSpanElement>) => {
    e.stopPropagation();
    const newOrder: SortOrder = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(newOrder);
    onChange(selectedField, newOrder);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="position-relative" ref={dropdownRef}>
      <div className="d-flex d-lg-none flex-column">
        <div className="h-10px"></div>
        <div className="d-flex gap-5 align-items-center justify-content-center fs-13 text-black">
          <div className="fw-400">Sort By</div>
          <div className="fw-700" onClick={toggleDropdown}>
            {selectedField}
          </div>
          <div onClick={toggleSortOrder}>
            <SortBy sort_order={sortOrder} fill="#167E76" />
          </div>
        </div>
        <div className="h-10px"></div>
      </div>
      {isDropdownOpen && (
        <div className="position-absolute start-50 translate-middle-x d-flex flex-column dropdown-menu">
          {sortFields.map((field) => (
            <div
              key={field}
              className="dropdown-item cursor-pointer text-nowrap"
              onClick={() => handleFieldChange(field)}
            >
              {field}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SortFilterDropdown;
